import { HeaderTestIds } from '@trello/webdriverio-tests';
import { IconName } from 'app/common/components/controls/icon';
import React, { lazy, Suspense, FunctionComponent, useCallback } from 'react';
import { Noun, Verb, trackUe } from '@trello/analytics';
import HeaderButton from './button';
import { usePopover, Popover } from '@trello/nachos';
import { forNamespace } from 'app/common/lib/util/i18n';
const viewTitle = forNamespace('view title');

const HeaderInfoMenuPopoverPromise = import(
  /* webpackChunkName: "info-menu-popover" */ 'app/gamma/src/components/popovers/header-info-menu'
);
const HeaderInfoMenuPopover = lazy(() => HeaderInfoMenuPopoverPromise);

export const InfoMenuButton: FunctionComponent = () => {
  const { toggle, triggerRef, popoverProps } = usePopover<HTMLButtonElement>();

  const onClick = useCallback(() => {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.INFO_MENU,
      method: 'clicking info header button',
    });
    toggle();
  }, [toggle]);

  return (
    <>
      <HeaderButton
        icon={IconName.Information}
        onClick={onClick}
        ref={triggerRef}
        testId={HeaderTestIds.InfoButton}
      />
      <Popover {...popoverProps} title={viewTitle('information')} size="large">
        <Suspense fallback={null}>
          <HeaderInfoMenuPopover />
        </Suspense>
      </Popover>
    </>
  );
};
